import { ATTENSI_PRODUCT_PLATFORM_FOR_OS } from "../constants"

export const getStaticLauncherLink = () => {
  switch (ATTENSI_PRODUCT_PLATFORM_FOR_OS) {
    case "MacOS":
      return "https://webcontent.attensi.com/download/attensi-launcher.pkg"
    case "Windows":
    default:
      return "https://webcontent.attensi.com/download/attensi-launcher.msi"
  }
}
